// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3D-t5","buttons":"RemoveExpirationActionButtons_buttons__3bFBr"};